import React from 'react'
import { CheckboxThemesType } from '../../libraries/CheckboxThemes'
import { TooltipPositionTypes } from '../../libraries/Tooltips'
import { getMergedClassNames } from '../../utils/HTMLutils'
import './Checkbox.scss'
const rootClassName = 'component-checkbox'

interface CheckboxProps {
  'tooltip-position'?: TooltipPositionTypes
  'tooltip-text'?: string
  disabled?: boolean
  value?: boolean
  onChange?: (value: boolean) => void
  theme: CheckboxThemesType
}

export default function Checkbox(props: CheckboxProps) {
  const handleClick = (evt: any) => {
    if (typeof props.onChange === 'function' && !props.disabled) {
      props.onChange(!props.value)
      evt.stopPropagation()
    }
  }

  const getProps = () => {
    const p: any = {
      ...props,
      className: getMergedClassNames([
        rootClassName,
        `${rootClassName}-${props.theme}`,
        `${rootClassName}-${props.value ? 'checked' : 'not'}`
      ]),
      onClick: handleClick
    }
    delete p.value
    delete p.onChange
    delete p.theme
    return p
  }

  return <button {...getProps()} />
}

Checkbox.defaultProps = {
  disabled: false,
  value: false,
  theme: 'primary',
  onChange: () => {}
}
